enum AuthorizationType {
    Customer = 1,
    ManualInPerson,
    ManualByPhone,
    ManualByText,
    ManualyByEmail,
}

export default AuthorizationType;
